import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {sx} from './sx'
import {MuiViewRenderProps} from "../types";
import moment from 'moment'
import Typography from '@mui/material/Typography';


const MuiSelectHoursAndMinutes: FC<MuiViewRenderProps> = ({
                                                              value,
                                                              onChange,
                                                              onClose,
                                                              format,
                                                          }) => {
    const {t} = useTranslation()

    const hours = Array.from({length: 24}, (_, i) => {
        return {
            hour: i,
            label: i > 9 ? i : `0${i}`
        }
    }).map(({hour, label}) => {
        const onClick = () => {
            onChange(moment(value).hour(hour))
        }
        const active = moment(value)?.hour() === hour;

        return (
            <Box
                sx={{
                    ...sx.item,
                    backgroundColor: active ? 'var(--account-accent, #0C6DDF)' : 'transparent',
                    color: active ? 'white' : undefined
                }}
                key={hour}
                onClick={onClick}
            >
                {label}
            </Box>
        )
    });

    const minutes = Array.from({length: 60}, (_, i) => {
        return {
            minute: i,
            label: i > 9 ? i : `0${i}`
        }
    }).map(({minute, label}) => {
        const onClick = () => {
            onChange(moment(value).minutes(minute))
        }
        const active = moment(value)?.minutes() === minute;

        return (
            <Box
                sx={{
                    ...sx.item,
                    backgroundColor: active ? 'var(--account-accent, #0C6DDF)' : 'transparent',
                    color: active ? 'white' : undefined
                }}
                key={minute}
                onClick={onClick}
            >
                {label}
            </Box>
        )
    });

    return (
        <Stack
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            sx={sx.root}
        >
            <Typography
                sx={sx.title}
                variant={'body2'}
            >
                {t('base.time')}
            </Typography>

            <Stack
                direction={'row'}
                gap={'10px'}
            >
                <Stack
                    sx={sx.list}
                >
                    {hours}
                </Stack>
                <Stack
                    sx={sx.list}
                >
                    {minutes}
                </Stack>
            </Stack>
        </Stack>
    )
};

export default MuiSelectHoursAndMinutes;